<template>
	<div class="obras-cadastro-dialog">
		<Dialog class="modal-confirmacao-remover" :visible.sync="showRemoverObra" :modal="true" :closable="false" :style="{ width: '460px', maxWidth: '92vw' }">
			<div class="p-3">
				<div class="d-flex align-items-center mb-3">
					<div class="modal-icon-danger mr-3 d-flex align-items-center justify-content-center">
						<i class="pi pi-trash" style="font-size: 1.5rem; color: #dc3545;"></i>
					</div>
					<div>
						<h5 class="mb-0 font-weight-bold text-dark">Excluir Obra?</h5>
						<small class="text-muted">Confirmação de exclusão permanente</small>
					</div>
				</div>

				<p class="text-secondary mb-2" style="font-size: 0.95rem;">
					Tem certeza que deseja remover o seguinte cadastro de obra?
				</p>

				<div class="p-2 mb-3 bg-light rounded border text-dark font-weight-bold" style="font-size: 0.95rem; word-break: break-word;">
					<i class="pi pi-building mr-1 text-muted"></i>
					{{ (obras && (obras.detail || obras.nome)) ? (obras.detail || obras.nome) : 'Obra selecionada' }}
				</div>

				<div class="d-flex justify-content-end align-items-center mt-3 pt-3 border-top">
					<Button @click="showRemoverObra = false" type="button" label="Cancelar"
						class="p-button-outlined p-button-secondary mr-2" icon="pi pi-times" />
					<Button @click="removerObra()" type="button" label="Sim, Remover"
						class="p-button-danger" icon="pi pi-trash" :disabled="loading" />
				</div>
			</div>
		</Dialog>
		<Dialog class="obras-modal" :visible.sync="showCadastroObra" :modal="true" :closable="false" :style="{ width: '65vw', maxWidth: '950px', minWidth: '400px' }">
			<h1 class="titulo-header d-flex justify-content-between align-items-center mb-2">
				<span>{{ headerDialog }}</span>
				<Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary"
					@click="showCadastroObra = false" title="Fechar" />
			</h1>
			<div id="topo" class="scrolable-dialog">
				<error-list :erros="erros" />
				
				<div class="alert alert-info py-2 px-3 mb-3 d-flex align-items-center" role="alert" style="font-size: 0.88rem; border-left: 4px solid #17a2b8; background-color: #f0f9fb; border-radius: 6px;">
					<i class="pi pi-info-circle mr-2 text-info" style="font-size: 1.25rem;"></i>
					<div>
						Os campos de <strong>identificação fiscal</strong> (CNO/CEI, CIB, Alvará e Inscrição) <strong>não são obrigatórios</strong>. Obrigatórios apenas os <strong>dados de endereço</strong> marcados com asterisco (<span class="text-danger">*</span>).
					</div>
				</div>

				<form name="form" @submit.prevent="onSubmit" autocomplete="off">
					<!-- Bloco 1: Dados Opcionais -->
					<div class="card mb-3 border-light shadow-sm" style="background-color: #fafbfc; border-radius: 8px;">
						<div class="card-body p-3">
							<div class="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
								<span class="font-weight-bold text-secondary" style="font-size: 0.92rem;">
									<i class="pi pi-id-card mr-1 text-muted"></i> Dados de Registro da Obra
								</span>
								<span class="badge badge-light border text-secondary px-2 py-1 font-weight-normal">Opcional</span>
							</div>
							<div class="row">
								<div class="col-md-3 col-sm-6 mb-2">
									<label class="text-muted small mb-1">Número CNO/CEI: <span class="font-italic text-muted">(opcional)</span></label>
									<span class="p-fluid">
										<InputText type="text" maxlength="30" v-model="obras.numeroCei" placeholder="Ex: 00.000.00000/00" autocomplete="off" />
									</span>
								</div>
								<div class="col-md-3 col-sm-6 mb-2">
									<label class="text-muted small mb-1">Código CIB: <span class="font-italic text-muted">(opcional)</span></label>
									<span class="p-fluid">
										<InputText type="text" v-model="obras.codigoCib" maxlength="8" placeholder="Ex: 00000000" autocomplete="off" />
									</span>
								</div>
								<div class="col-md-3 col-sm-6 mb-2">
									<label class="text-muted small mb-1">Número Alvará: <span class="font-italic text-muted">(opcional)</span></label>
									<span class="p-fluid">
										<InputText type="text" maxlength="30" v-model="obras.numeroAlvara" placeholder="Ex: 0000/2026" autocomplete="off" />
									</span>
								</div>
								<div class="col-md-3 col-sm-6 mb-2">
									<label class="text-muted small mb-1">Inscrição Imobiliária: <span class="font-italic text-muted">(opcional)</span></label>
									<span class="p-fluid">
										<InputText type="text" maxlength="30" v-model="obras.inscImobiliaria" placeholder="Ex: 00.00.000" autocomplete="off" />
									</span>
								</div>
							</div>
						</div>
					</div>

					<!-- Bloco 2: Localização e Endereço (Obrigatórios) -->
					<div class="card mb-3 border-light shadow-sm" style="border-radius: 8px;">
						<div class="card-body p-3">
							<div class="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
								<span class="font-weight-bold text-dark" style="font-size: 0.92rem;">
									<i class="pi pi-map-marker mr-1 text-primary"></i> Localização e Endereço da Obra
								</span>
								<span class="badge badge-primary px-2 py-1 font-weight-normal">Obrigatório</span>
							</div>

							<!-- Linha 1: Nome da Obra e CEP -->
							<div class="row">
								<div class="col-md-8 mb-2">
									<label for="nome" class="font-weight-bold small mb-1">Nome / Descritivo da Obra: <span class="text-danger">*</span></label>
									<span class="p-fluid">
										<InputText type="text" id="nome" name="obra-nome" v-model="obras.nome" placeholder="Identificação ou nome da obra" autocomplete="off" />
									</span>
								</div>
								<div class="col-md-4 mb-2">
									<label for="cep" class="font-weight-bold small mb-1">CEP: <span class="text-danger">*</span></label>
									<span class="p-fluid">
										<InputMask id="cep" v-model="obras.cep" name="obra-cep" mask="99.999-999" placeholder="00.000-000" autocomplete="off" />
									</span>
								</div>
							</div>

							<!-- Linha 2: Endereço, Número e Bairro -->
							<div class="row">
								<div class="col-md-6 mb-2">
									<label for="enderecoObra" class="font-weight-bold small mb-1">Endereço (Rua, Av., Logradouro): <span class="text-danger">*</span></label>
									<span class="p-fluid">
										<InputText id="enderecoObra" name="enderecoObra" v-model="obras.enderecoObra" maxlength="255" placeholder="Logradouro da obra" autocomplete="off" />
									</span>
								</div>
								<div class="col-md-2 mb-2">
									<label for="numero" class="font-weight-bold small mb-1">Número: <span class="text-danger">*</span></label>
									<span class="p-fluid">
										<InputText id="numero" type="text" maxlength="60" name="obra-numero" v-model="obras.numero" placeholder="Nº ou S/N" autocomplete="off" />
									</span>
								</div>
								<div class="col-md-4 mb-2">
									<label for="bairro" class="font-weight-bold small mb-1">Bairro: <span class="text-danger">*</span></label>
									<span class="p-fluid">
										<InputText id="bairro" type="text" maxlength="60" name="obra-bairro" v-model="obras.bairro" placeholder="Bairro" autocomplete="off" />
									</span>
								</div>
							</div>

							<!-- Linha 3: Complemento -->
							<div class="row">
								<div class="col-md-12 mb-1">
									<label for="complemento" class="text-muted small mb-1">Complemento: <span class="font-italic text-muted">(opcional)</span></label>
									<span class="p-fluid">
										<InputText id="complemento" type="text" maxlength="150" name="obra-complemento" v-model="obras.complemento" placeholder="Apto, Bloco, Quadra, Ponto de referência, etc." autocomplete="off" />
									</span>
								</div>
							</div>
						</div>
					</div>

					<div class="d-flex justify-content-end align-items-center mt-3 pt-2 border-top">
						<Button @click="showCadastroObra = false" type="button" label="Cancelar"
							class="p-button-outlined p-button-secondary mr-2" icon="pi pi-times" />
						<Button @click="salvar()" type="button" label="Gravar Obra"
							class="p-button-success" icon="pi pi-check" :disabled="loading" />
					</div>
				</form>
			</div>
		</Dialog>
	</div>
</template>

<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import obrasService from '../services/obras/obras.service';
import Obras from '../models/obras/Obras';

export default {
	name: 'ObrasCadastroDialog',
	data() {
		return {
			erros: [],
			modoEdicao: false,
			showCadastroObra: false,
			showRemoverObra: false,
			loading: false,
			money: money,
			filtro: "",
			filteredTipoObra: null,
			selectedTipoObra: null,
			filteredTipoDesconto: null,
			selectedTipoDesconto: null,
			obras: new Obras(),
		}
	},
	created() {
		this.$root.$on("notaFiscal:novaObra", () => {
			this.limparForm();
			this.modoEdicao = false;
			this.showCadastroObra = true;
			this.showRemoverObra = false;
		});
		this.$root.$on("notaFiscal:editarObra", () => {
			this.obras = this.$parent.selectedObra;
			this.modoEdicao = true;
			this.showCadastroObra = true;
			this.showRemoverObra = false;
		});
		this.$root.$on("notaFiscal:removerObra", () => {
			this.obras = this.$parent.selectedObra;
			this.showCadastroObra = false;
			this.showRemoverObra = true;
		});

		this.currentUser = LoginService.currentUserValue;

	},

	methods: {

		salvar() {
			this.processando(true);
			this.obras.idCliente = this.currentUser.usuario.idCliente;
			this.obras.idContribuinteCadastro = this.currentUser.contribuinte.idContribuinte;

			obrasService.saveObras(this.obras).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Obra salva com sucesso!"
					});
					if (data && data.data) {
						this.$parent.selectedObra = data.data;
						if (this.$parent.atualizarDadosObra) {
							this.$parent.atualizarDadosObra();
						}
					}
					this.showCadastroObra = false;
				},
				(error) => {
					const erros = error.response.data;
					this.erros.push(...erros);

					if (!this.erros.length) {
						this.$root.$emit(
							"alert:error",
							"Houve um problema ao salvar a Obra!"
						);
					}
				}
			);
			this.processando(false);
		},
		removerObra() {
			if (this.obras && this.obras.id) {
				this.$parent.processando(true);
				obrasService.removeObras(this.obras.id).then(
					data => {
						console.log(data);
						this.$toast.add({
							severity: "success",
							summary: "Obra removida com sucesso"
						});
					},
					error => {
						let errorMessage = "Houve um problema ao remover a Obra!";
						if (error.response) {
							errorMessage = error.response.data;
						}
						this.$toast.add({
							severity: "error",
							summary: errorMessage
						});
					}
				).then(() => {

					this.$parent.selectedObra = null;
					this.showRemoverObra = false;
					this.$parent.processando(false);
				});

			}
		},

		limparForm() {
			this.erros = [];
			this.obras.id = null;
			this.obras.saldoDisponivel = 0;
			this.obras.saldoDeduzido = 0;
			this.obras.codigoCib = '';
			this.obras.numeroCei = '';
			this.obras.numeroArt = '';
			this.obras.numeroAlvara = '';
			this.obras.nome = '';
			this.obras.dataInicio = '';
			this.obras.dataTermino = '';
			this.obras.enderecoObra = '';
			this.obras.cep = '';
			this.obras.numero = '';
			this.obras.complemento = '';
			this.obras.bairro = '';
			this.obras.inscImobiliaria = '';
			this.selectedTipoObra = null;
			this.selectedTipoDesconto = null;
			this.obras.descricao = '';
		},

		processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		},

	}, computed: {
		headerDialog() {
			return (
				(this.modoEdicao
					? "Edição de "
					: "Cadastro de ") +
				"Obra"
			);
		}
	}
}
</script>

<style scoped>
::v-deep .p-dialog-content {
	overflow: hidden !important;
	padding: 0.5rem 1rem 1rem 1rem !important;
}

.scrolable-dialog {
	padding: 0 6px 0 2px;
	width: 100%;
	max-height: 75vh;
	overflow-y: auto;
	overflow-x: hidden;
}

.scrolable-dialog::-webkit-scrollbar {
	width: 6px;
}

.scrolable-dialog::-webkit-scrollbar-thumb {
	background-color: #cbd5e1;
	border-radius: 4px;
}

.scrolable-dialog::-webkit-scrollbar-thumb:hover {
	background-color: #94a3b8;
}

.titulo-header {
	font-size: 1.25rem;
	font-weight: 700;
	color: #1e293b;
	padding: 0.25rem 0.5rem;
}

.p-inputtext:disabled {
	color: #a6a6a6;
	border-color: #a6a6a6;
}

.card {
	border-color: #e2e8f0;
}

.modal-icon-danger {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: #fee2e2;
	flex-shrink: 0;
}
</style>